import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Leia toode kategooria või märksõna järgi

  <span style="color:#85c1dc;">**FI:**</span>
  Etsi tuote kategorian tai hakusanan mukaan

  <span style="color:#85c1dc;">**RU:**</span>
  Найдите продукт по категории или ключевому слову
*/
/* @__NO_SIDE_EFFECTS__ */
const m397 = msg(
  mf`Leia toode kategooria või märksõna järgi`,
  mf`Etsi tuote kategorian tai hakusanan mukaan`,
  mf`Найдите продукт по категории или ключевому слову`,
)

export { m397 as 'w.module.categories_search.title' }